export const GET_COPYWRITER_SUCCESS = "GET_COPYWRITER_SUCCESS";
export const SAVE_COPYWRITER_SUCCESS = "SAVE_COPYWRITER_SUCCESS";